import React from 'react';
import {Translate} from '../../../config/TranslationProvider';
import EventsContent from '../content/EventsContent';
import config from '../../../config/config';
import DefaultHeader from '../head/DefaultHeader';
import {useFilter} from '../../../api/hooks';
import Loader from '../Loader';
import Error from '../Error';

const Events = () => {
    const {data: customFilter, isLoading: filterLoading, error: filterError} = useFilter();

    if (filterLoading) {
        return <Loader />;
    }

    if (filterError) {
        return <Error errors={[filterError]} />;
    }

    return (
        <>
            <DefaultHeader customFilter={customFilter} image={config.images.pages.events} title={<Translate value="events" />} />
            <EventsContent customFilter={customFilter} />
        </>
    );
};

export default Events;
